import React, { useCallback, useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import getTableColumns from '@/finsight/ui/components/staticPages/Pricing/ComparePlansPanel/tableColumns';
import tableData from '@/finsight/ui/components/staticPages/Pricing/ComparePlansPanel/tableData';
import { StickyDataTable, dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import Select from '@/Framework/UI/Molecules/Form/Select/legacy';
import { UserPlanType } from '@/users/domain/UserPlan';
import { isScreenS } from '@dealroadshow/uikit/core/styles/screen/screen';

import styles from '@/finsight/ui/components/staticPages/Pricing/styles.scss';

const COMPARE_SELECT_OPTIONS = [
  { value: UserPlanType.STARTER, label: 'Plan: Starter' },
  { value: UserPlanType.PREMIUM, label: 'Plan: Premium' },
  { value: UserPlanType.PRO, label: 'Plan: Professional' },
];

const getDefaultSelectedPlan = () => (isScreenS() ? UserPlanType.STARTER : null);

const ComparePlansTable = () => {
  const [isMobile, setIsMobile] = useState(isScreenS());
  const [selectedPlan, setSelectedPlan] = useState(null);

  const onResize = useCallback(throttle(() => setIsMobile(isScreenS()), 100), [setIsMobile]);

  const onChangeSelectedPlan = useCallback((plan: { value: string }) => {
      setSelectedPlan(plan.value);
  }, [setSelectedPlan]);

  useEffect(() => {
    window.addEventListener('resize', throttle(onResize, 100));
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    setSelectedPlan(getDefaultSelectedPlan());
  }, [isMobile]);

  return (
    <div className={ styles.comparePlansTableWrapper }>
      <div className={ styles.comparePlansSelectWrapper }>
        <Select
          name="comparePlansSelect"
          dataTest="comparePlansSelect"
          searchable={ false }
          isNarrow
          options={ COMPARE_SELECT_OPTIONS }
          value={ selectedPlan }
          onChange={ onChangeSelectedPlan }
        />
      </div>

      <StickyDataTable
        stickyDataTableContainer={ styles.comparePlansTable }
        className={ dataTableStyles.isHoverable }
        containerClassName={ styles.comparePlansTableContainer }
        dataTest="comparePlansTable"
        columns={ getTableColumns(selectedPlan) }
        data={ tableData }
      />

      <div className={ styles.comparePlansFooter }>* TRACE quotes are delayed by 4 hours from reporting.</div>
    </div>
  );
};

export default ComparePlansTable;
